import React, { useState } from 'react';
import { AlertTriangle, ShieldAlert, HeartPulse, Stethoscope, UserCog, MapPin } from 'lucide-react';

function cx(...classes) {
    return classes.filter(Boolean).join(' ');
}

// Maps a member's role (or the default "incident" marker) to an icon + color,
// mirroring the mockup's .smart-marker role variants.
const ROLE_CONFIG = {
    incident: { icon: AlertTriangle, className: 'bg-red-700' },
    rsos: { icon: ShieldAlert, className: 'bg-seha-500' },
    nurses: { icon: HeartPulse, className: 'bg-orange-500' },
    doctors: { icon: Stethoscope, className: 'bg-green-600' },
    admins: { icon: UserCog, className: 'bg-purple-600' },
};

const IncidentMarker = ({ name = 'Sadia', distance = '2', team = 'brown', showDetails = false, role = 'incident' }) => {
    const [open, setOpen] = useState(false);

    const config = ROLE_CONFIG[role] || { icon: MapPin, className: 'bg-neutral-500' };
    const Icon = config.icon;

    const handleEnter = () => {
        if (showDetails) setOpen(true);
    };
    const handleLeave = () => setOpen(false);

    return (
        <div className="relative">
            <button
                type="button"
                onMouseOver={handleEnter}
                onMouseLeave={handleLeave}
                onFocus={handleEnter}
                onBlur={handleLeave}
                className={cx('smart-marker', config.className)}
                aria-label={name}
            >
                <Icon className="w-[18px] h-[18px]" />
            </button>

            {open && showDetails && (
                <div className="absolute z-30 bottom-full left-1/2 -translate-x-1/2 mb-3 w-56 bg-white rounded-xl border border-neutral-200 shadow-panel p-3.5 text-xs pointer-events-none dark:bg-ink-900 dark:border-neutral-700">
                    <p className="text-sm font-bold text-neutral-900 truncate dark:text-neutral-50">{name}</p>
                    <div className="mt-2 space-y-1 text-neutral-500 dark:text-neutral-500">
                        <p><span className="font-semibold text-neutral-700 dark:text-neutral-300">Role:</span> {role}</p>
                        <p><span className="font-semibold text-neutral-700 dark:text-neutral-300">Team:</span> {team}</p>
                        <p><span className="font-semibold text-neutral-700 dark:text-neutral-300">Distance:</span> {distance}km</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default IncidentMarker;
